import CusPagination from '@/components/cusPagination.vue';
import {journalList} from '../../api/url'
/**
 * @author：
 * @update：
 * @description：
 **/
export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            name:'',//操作人员
            timer:[],//操作时间

            tabs:'0',
            tableData: [],//表格数据
            tableData2: [],//表格数据
            page: 1,
            size: 10,
            count:0,
        };
    },
    // 自定义方法
    methods: {
        resetBtn(){
            this.name = '';
            this.timer = [];
            this.page=1;
            this.journalData()
        },
        //切换
        dataList(type){
            if(type==0){
                this.journalData()
            }else{

            }
        },
        //系统日志
        journalData(){
            let data = {
                username:this.name,
                pageNumber:this.page,
                pageSize:this.size
            };
            if(this.timer!=''&&this.timer!=null){
                data.createdDate=this.timer.length==0?'':this.timer.join(',')
            }
            this.$ajax.get(journalList,data).then(res=>{
                console.log(res);
                this.tableData = res.data.rows;
                this.count = res.data.total;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        },
    },
    // 数据观察监听
    watch: {
        page(newData,oldData){
            this.journalData()
        },
        size(newData,oldData){
            this.page = 1;
            this.journalData()
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {
        this.journalData()
    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
